import { Box, SxProps, Typography } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import React from "react";

export default function LessonNumber({
  lessonNumber,
  sx = {},
  prefix,
  prefixSx,
}: {
  lessonNumber?: number | null;
  sx?: SxProps;
  prefix?: string;
  prefixSx?: SxProps;
}) {
  const { t } = useTranslation(
    "ui-components-classroom\\components\\syllabus\\LessonNumber",
  );
  if (!lessonNumber) {
    return null;
  }
  return (
    <Typography
      emphasized
      variant="caption"
      sx={{
        // TODO: Remove uppercase to match design system
        textTransform: "uppercase",
        color: "info.700",
        ...(Array.isArray(sx) ? sx : [sx]),
      }}
    >
      {t("Lesson {{lessonNumber}}", { lessonNumber })}
      {prefix && ": "}
      <Box sx={{ display: "inline", ...prefixSx }}>{prefix}</Box>
    </Typography>
  );
}
